import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getConferenceOptions } from '@/module/Conference';
import { ConferenceEdit } from '@/module/Conference/ConferenceEdit';

export const Route = createFileRoute('/_auth/conference/_conference/$conferenceId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { conferenceId } = Route.useParams();
  const { data: conference } = useSuspenseQuery(getConferenceOptions(conferenceId));

  return <ConferenceEdit conference={conference} />;
}
